import { useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/washflow/Logo";

const links = [
  { label: "The Problem", href: "#problem" },
  { label: "Solution", href: "#solution" },
  { label: "Plans", href: "#pricing" },
  { label: "Reporting", href: "#reporting" },
  { label: "Add-ons", href: "#addons" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="header-navigation" className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-[#E2E8F0]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" aria-label="WashFlow — back to top">
          <Logo />
        </a>
        <nav className="hidden lg:flex items-center gap-6">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`} className="text-sm font-medium text-[#2C3E50] hover:text-[#1ABC9C] transition-colors">
              {l.label}
            </a>
          ))}
          <a href="#contact" data-testid="nav-get-started-btn" className="bg-[#1ABC9C] hover:bg-[#16A085] text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors">
            Get Started
          </a>
        </nav>
        <button data-testid="nav-mobile-menu-btn" className="lg:hidden p-2 text-[#1B4F72]" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="lg:hidden bg-white border-t border-[#E2E8F0] px-4 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-base font-medium text-[#2C3E50] py-1">
              {l.label}
            </a>
          ))}
          <a href="#contact" onClick={() => setOpen(false)} className="bg-[#1ABC9C] text-white text-center font-bold px-5 py-3 rounded-full">
            Get Started
          </a>
        </nav>
      )}
    </header>
  );
}
